export default __webpack_public_path__ + "static/media/valleyPort10.adac60ea.png";